import React, { useState, useEffect } from 'react';
import FeedItemCard from './FeedItemCard';
import FeedModal from './FeedModal';
import ArticleFeatured from './ArticleFeatured';

export default function FeedGrid() {
  const [posts, setPosts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  async function loadLocalFeed() {
    setLoading(true);
    try {
      const res = await fetch('/local-output.json');if (!res.ok) throw new Error(`Failed to fetch local feed: ${res.status} ${res.statusText}`);
      const data = await res.json();
      const sorted = data.sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
      setPosts(sorted);
    } catch (err) {
      console.error('Failed to load local feed:', err);
    }
    setLoading(false);
  }

  useEffect(() => {
    loadLocalFeed();
  }, []);

  return (
    <>
    <ArticleFeatured />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '20px',
          padding: '20px',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            gridColumn: '1 / -1',          // span all columns
            backgroundColor: '#333',       // dark grey background
            color: '#fff',                 // white text
            padding: '10px 20px',
            borderRadius: '4px',
            textAlign: 'center', 
            margin: "0px"          // center the heading
          }}
        >
          <h2 style={{ margin: 0, color:"#fff" }}>The Feeds</h2>
        </div>
        {posts.map(item => (
          <FeedItemCard
            key={item.id}
            item={item}
            onClick={() => setSelected(item)}
          />
        ))}
      </div>
      {selected && (
        <FeedModal item={selected} onClose={() => setSelected(null)} />
      )}
    </>
  );
}
